import EnumsApiService from '@services/enums.api.service';

import { MutationTypes, ActionTypes } from './enums.types';

// const generateEnumByKeyValue = (obj, { key, value }) => {
//   obj[key] = value;
//   return obj;
// };

export default {
  namespaced: true,
  state: {
    enums: {},
  },
  mutations: {
    [MutationTypes.SET_ENUMS](state, payload) {
      state.enums = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_ENUMS]({ commit }) {
      commit(MutationTypes.SET_ENUMS, await EnumsApiService.getEnums());
    },
  },
  getters: {},
};
